import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import themeColors from "../theme";

export default function MarketplaceProductCard({ product, onViewDetails }) {
    const { teal, darkTeal } = themeColors;
    const isFree = !product.price || product.price === 0;
    const ctaLabel = (product.category === "Podcast" || product.category === "Online Education") ? "Open Link" : "View Details";
    const fallbackImage = product.category === "Medical Equipment"
        ? "/images/medical-equipment/default.svg"
        : "/images/books/book-default.png";

    const handlePrimaryAction = (e) => {
        e?.stopPropagation?.();
        onViewDetails && onViewDetails(product);
    };

    return (
        <Card
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                borderRadius: 2,
                border: "none",
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                transition: "box-shadow 0.2s ease",
                cursor: "pointer",
                overflow: "hidden",
                backgroundColor: "#fff",
                "&:hover": {
                    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                },
            }}
            onClick={handlePrimaryAction}
        >
            {/* Image Container */}
            <Box
                sx={{
                    height: 160,
                    flexShrink: 0,
                    backgroundColor: "#f5f5f5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                }}
            >
                <Box
                    component="img"
                    src={product.image || fallbackImage}
                    alt={product.title || product.name}
                    sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                    }}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = fallbackImage;
                    }}
                />
            </Box>

            <CardContent
                sx={{
                    p: 1.5,
                    pt: 1.25,
                    pb: 1.5,
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                }}
            >
                <Box
                    sx={{
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        lineHeight: 1.35,
                        color: "#2C3E50",
                        height: 38,
                        overflow: "hidden",
                        mb: 0.25,
                        flexShrink: 0,
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        textOverflow: "ellipsis",
                    }}
                >
                    {product.title || product.name}
                </Box>

                <Typography
                    variant="body2"
                    sx={{ fontSize: "0.8rem", color: "#6c757d", mb: 0.5 }}
                >
                    {product.category || "Books"}
                </Typography>

                <Typography
                    sx={{
                        color: teal,
                        fontWeight: 700,
                        fontSize: "1rem",
                        mb: 1.25,
                    }}
                >
                    {isFree
                        ? "Free"
                        : `$${Number(product.price) % 1 === 0 ? Number(product.price) : Number(product.price).toFixed(2)}`}
                </Typography>

                <Button
                    variant="contained"
                    size="small"
                    fullWidth
                    onClick={handlePrimaryAction}
                    sx={{
                        mt: "auto",
                        backgroundColor: teal,
                        color: "white",
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: "0.8125rem",
                        borderRadius: 1.5,
                        py: 0.75,
                        boxShadow: "none",
                        "&:hover": {
                            backgroundColor: darkTeal,
                            boxShadow: "none",
                        },
                    }}
                >
                    {ctaLabel}
                </Button>
            </CardContent>
        </Card>
    );
}
